import Vue from 'vue';
import VueRouter from 'vue-router';
import box from '@/page/box';
import spectaculars from '@/page/spectaculars'; // 大屏监控
import province from '@/page/province'; // 已预授信企业
import notApplyCompany from '@/page/not-apply-company'; // 未申请企业列表
import companyList from '@/page/company-list'; // 企业列表
import anomaly from '@/page/anomaly'; // 异动列表
import applyDetail from '@/page/apply-detail'; // 企业申请明细
import applyList from '@/page/apply-list'; // 产品申请列表明细
import statistics from '@/page/statistics'; // 企业货值统计
import map from '@/page/map'; // 地图业务分布图
import home from '@/page/home'; // 首页统计

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/databoard'
  },
  {
    path: '/databoard',
    component: box,
    name: 'databoard',
    children: [
      {
        path: '/home',
        name: 'home',
        component: home
      },
      {
        path: '/province',
        name: 'province',
        component: province
      },
      {
        path: '/company-list',
        name: 'company-list',
        component: companyList
      },
      {
        path: '/not-apply-company',
        name: 'not-apply-company',
        component: notApplyCompany
      },
      {
        path: '/anomaly',
        name: 'anomaly',
        component: anomaly
      },
      {
        path: '/apply-detail',
        name: 'apply-detail',
        component: applyDetail
      },
      {
        path: '/apply-list',
        name: 'apply-list',
        component: applyList
      },
      {
        path: '/statistics',
        name: 'statistics',
        component: statistics
      }
    ]
  },
  {
    path: '/businessboard',
    name: 'businessboard',
    component: spectaculars
  },
  {
    path: '/public_databoard',
    name: 'public_databoard',
    component: map
  }
];

const router = new VueRouter({
  routes
});

export default router;
